module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-italic-f5c365f29f0193e60cf4927c7ce5b5b5.eot";